import { IDriverSessionDetail } from '../types/session';

export const FALLBACK_LABEL = '-';

export const getTeamNameDriverSessionDetail = (row: IDriverSessionDetail): string =>
    (row.customTeamName || row.team.name) ?? FALLBACK_LABEL;